import Steampage from "./Staempage";
import Steammiddel from "./Stemmiddel";
import Stem_Action from './Stem_Action'
import Boring_lecture from './Boring-lecture'
import Products from './Products'
export default function SteamPage_main() {
    return (
        <>
            <div>
                <Steampage />
            </div>
             <div>
                <Steammiddel />
            </div>
             <div>
                <Stem_Action />
            </div> 
            <div>
                <Boring_lecture/>
            </div>
            <div>
                <Products/>
            </div>  
           
        </>
    );
}
